var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-stretch",attrs:{"id":"tenants"}},[_c('navigation'),_c('tenantslist',{attrs:{"collapseSidebar":_vm.collapseSidebar},on:{"hideSidebar":function($event){_vm.collapseSidebar = false},"showSidebar":function($event){_vm.collapseSidebar = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }